var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1272_1700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.78 24.5866L15.2711 23.0388L10.3103 13.2924L12.5538 9.84839L18.4343 21.4493L20.7196 21.0727L13.9055 8.37041H28.5789L21.7647 21.0727L24.05 21.4493L29.9305 9.84839L32.1881 13.2924L27.2132 23.0388L28.7044 24.5866L34.3061 14.0593C34.5709 13.5992 34.5569 13.0693 34.2643 12.6371L30.488 6.85057C30.1954 6.44622 29.8469 6.26495 29.3035 6.26495H13.1948C12.6374 6.26495 12.289 6.44622 12.0103 6.85057L8.22002 12.6371C7.94133 13.0693 7.92739 13.5992 8.17822 14.0593L13.78 24.5866ZM16.0793 14.7704H26.419V12.665H16.0793V14.7704ZM21.2491 38C26.2936 38 30.3765 33.9147 30.3765 28.8671C30.3765 23.8057 26.2936 19.7203 21.2491 19.7203C16.1908 19.7203 12.1079 23.8057 12.1079 28.8671C12.1079 33.9147 16.1908 38 21.2491 38ZM21.2491 35.8946C17.3613 35.8946 14.212 32.7573 14.212 28.8671C14.212 24.9769 17.3474 21.8258 21.2491 21.8258C25.1231 21.8258 28.2723 24.9629 28.2723 28.8671C28.2723 32.7434 25.137 35.8946 21.2491 35.8946ZM18.7966 33.2733L21.2631 31.4746L23.7017 33.2733C24.2312 33.6497 24.7608 33.2593 24.5657 32.6736L23.5763 29.7595L26.0707 27.9747C26.5304 27.654 26.405 26.9848 25.7502 26.9848L22.6984 27.0127L21.7647 24.0845C21.5836 23.499 20.9147 23.499 20.7336 24.0845L19.7999 27.0127L16.7482 26.9848C16.1072 26.9848 15.9539 27.6401 16.4416 27.9887L18.936 29.7595L17.9466 32.6736C17.7515 33.2593 18.281 33.6497 18.7966 33.2733Z",
    fill: "#F2B950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1272_1700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 32,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.a2a35e7bd344c3634cdc4db1560cc363.svg";
export { ForwardRef as ReactComponent };